import _ from 'lodash'

const compareText = (left, right) => {
  return `${left || ''}`.localeCompare(`${right || ''}`, 'pt-BR', {
    sensitivity: 'base',
    numeric: true,
  })
}

export function sortCoberturasByDescricao(coberturas = []) {
  return _.clone(coberturas).sort((a, b) => {
    const descricaoCompare = compareText(_.get(a, 'descricao', ''), _.get(b, 'descricao', ''))
    if (descricaoCompare !== 0) {
      return descricaoCompare
    }

    return compareText(_.get(a, 'itemLancamento.oidTipo', ''), _.get(b, 'itemLancamento.oidTipo', ''))
  })
}
